import { pathLabel, type FieldIssue } from "@/components/auth/issues";

/** zod 오류 목록 , 어느 칸의 무슨 문제인지 한 줄씩 */
export function IssueNote({ title, issues, labels }: { title: string; issues: FieldIssue[]; labels?: Record<string, string> }) {
  if (!issues.length) return null;
  return (
    <div role="alert" className="note note-danger text-label">
      <p className="font-semibold">{title}</p>
      <ul className="issue-list">
        {issues.map((i, n) => (
          <li key={n}>
            <span className="font-mono">{pathLabel(i.path, labels)}</span>: {i.message}
          </li>
        ))}
      </ul>
    </div>
  );
}
